var INT_MAX_WIDTH_MENU = 720;
export var MAX_WIDTH_MENU = INT_MAX_WIDTH_MENU + "px";
export var DEFAULT_MAX_WIDTH_COLUMN = INT_MAX_WIDTH_MENU - 32 + "px";
//# sourceMappingURL=helpers.js.map